import ForgotPasswordPanel from './ForgotPasswordPanel';

export default ForgotPasswordPanel;
